import { Tween, Easing } from '@tweenjs/tween.js';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { COMPONENTS } from '../lib/constants';
import { QuestPageClaim } from '../view/quest/QuestPageClaimedView';
import { QuestPageClaimMobile } from '../view/quest/QuestPageClaimedMobileView';
class Modal {
	constructor(ui, layer) {
		this.ui = ui;
		this.layer = layer;
		this.modalViews = {
			notification: COMPONENTS.NOTIFICATION,
			quest: COMPONENTS.QUEST_PAGE,
			settings: COMPONENTS.SETTINGS_PAGE,
			bonus_buy: COMPONENTS.BONUS_BUY_PAGE,
			bonus_revive: COMPONENTS.BONUS_REVIVE_PAGE,
			fastplay_dialogue: COMPONENTS.FAST_PLAY_DIALOGUE,
			info: COMPONENTS.INFO_PAGE,
			auto_spin: COMPONENTS.AUTO_SPIN,
			win: COMPONENTS.WIN_HIGHLIGHT,
			freespin_win: COMPONENTS.FREE_SPIN_WIN,
			bonus_game: COMPONENTS.BONUS_GAME_DIALOGUE,
			bonus_game_finish: COMPONENTS.BONUS_GAME_FINISHED_DIALOGUE,
			quest_claim: COMPONENTS.QUEST_PAGE_CLAIM,
			prompt: COMPONENTS.PROMPT,
			quest_prompt: COMPONENTS.QUEST_PROMPT,
			freespin_prompt: COMPONENTS.FREESPIN_PROMPT
		};
	}

	modalChanged(e) {
		GameConfigs.modal = e.detail.modal;
		const modalToShow = e.detail.modal;
		const viewsToRemove = Object.keys(this.modalViews).filter(
			(modal) => modal !== modalToShow
		);
		viewsToRemove.forEach((modal) => {
			const viewName = this.modalViews[modal];
			if (this.ui[viewName]) {
				this.ui.removeView(this.ui[viewName]);
			}
		});
		if (e.detail.modal !== '') {
			this.ui.sortableChildren = true;
			this.layer.zIndex = 1;
			this.ui.addChildAt(this.layer, 0);
			this.tweener = new Tween(GameConfigs.reelComponent)
				.to({ alpha: 0.6 }, 100)
				.easing(Easing.Linear.None)
				.start();
		} else {
			this.ui.removeChild(this.layer);
			this.tweener = new Tween(GameConfigs.reelComponent)
				.to({ alpha: 1 }, 100)
				.easing(Easing.Linear.None)
				.start();
		}
		if (GameConfigs.modal === 'quest_claim') {
			this.ui.addView(
				window.isMobile || window.isTablet
					? QuestPageClaimMobile
					: QuestPageClaim
			);
		}
	}
}

export default Modal;
